import React from "react";
import PropTypes from "prop-types";
import { flatDeep, slugify, containsObject } from "../../../utils";
import { Link } from "react-router-dom";

const SidebarArchive = ({ data, path }) => {
    const postDate = data.map((item) => {
        return item.date;
    });
    let singleDateArray = flatDeep(postDate);
    let date = [];
    singleDateArray.forEach((cat) => {
        const obj = {
            title: cat.trim(),
            slug: slugify(cat),
            count: 1,
        };
        const objIndex = containsObject(obj, date);
        if (objIndex !== -1) {
            const prevCount = date[objIndex].count;
            date[objIndex] = {
                title: cat.trim(),
                slug: slugify(cat),
                count: prevCount + 1,
            };
        } else {
            date.push(obj);
        }
    });
    return (
        <ul className="widget-tags">
            {date.map((single, i) => {
                return (
                    <li
                        className="px-2 mx-1 my-2 top-button"
                        key={i}
                        style={{
                            outline: "",
                            borderRadius: "4px",
                        }}
                    >
                        <Link
                            to={process.env.PUBLIC_URL + path + single.slug}
                            style={{
                                color: "white",
                            }}
                        >
                            {single.title}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

SidebarArchive.propTypes = {
    data: PropTypes.array,
    path: PropTypes.array,
};

export default SidebarArchive;
